import React from 'react';
import ReactDOM from 'react-dom';
import {createNewVersion, initToggle, saveFiles} from '../helper';
import Notify from '@assets/js/input/notify';
import FileUploadBlock from './file_upload_btn';
import FileDeleteButton from './file_delete_btn';
import FileEdit from './file_edit_row';
import Nbsp from '../components/Nbsp';
import {doBlockPage, doUnblockPage} from '@assets/js/input/load_page_helper';

const notify = new Notify();

class ReactModalFileEdit extends React.Component {
    constructor(props) {
        super(props);
        this.filesDelIds = [];
        this.modal = React.createRef();
        let files = [];
        for (let index in this.props.files) {
            files.push(this.props.files[index]);
        }
        this.state = {
            lastClickedRowIdx: null,
            checked: false,
            files: files,
            setNewFiles: newfiles => {
                let tmp = this.state.files;
                let newIndex = 0;
                if (Object.keys(tmp).length) {
                    newIndex = parseInt(Object.keys(tmp)[Object.keys(tmp).length - 1]);
                }
                for (let index in newfiles) {
                    newIndex = newIndex + 1;
                    if (newfiles[index]) {
                        tmp[newIndex] = newfiles[index];
                    }

                }
                this.setState({files: tmp, lastClickedRowIdx: null});
                this.props.updateFilesList(tmp);
            },
            createNewUpdate: () => {
                createNewVersion();
            },
            filesDelIds: this.filesDelIds,
            deleteFiles: () => {
                $(this.modal.current).find('input[name=file-select]:checked').each((index, item) => {
                    let valueItem = parseInt($(item).val());
                    this.checkDelFiles(valueItem);
                });
                this.setState({checked: false});
            },
            sortColumn: 'sort_id',
            sortType: 'asc',
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.sortColumn !== this.state.sortColumn || prevState.sortType !== this.state.sortType) {
            var filesSorted = _.orderBy(this.state.files, this.state.sortColumn, this.state.sortType);
            this.setState({files: filesSorted});
        }
    };
    handleChangeEvent(name, value, index) {
        let files = this.state.files;
        files[index][name] = value;
        this.setState({files: files});
    };

    selectAll() {
        this.setState({checked: !this.state.checked}, () => {
            $(this.modal.current).find('input[name=file-select]:enabled').each((index, element) => {
                $(element).prop('checked', this.state.checked);
            });
        });
    }

    checkDelFiles(id) {
        let tmp = this.state.filesDelIds;
        tmp.push(id);
        this.setState({filesDelIds: tmp, lastClickedRowIdx: null});
    }

    updateCurrentFilesList(files) {
        let tmp = this.state.files;
        let objectKeys = Object.keys(this.state.files);
        let lastIndex = parseInt(objectKeys[objectKeys.length - 1]);
        files.forEach((file, i) => {
            tmp[lastIndex + 1 + i] = file;
        });
        for (let index in tmp) {
            if (index <= lastIndex) {
                delete tmp[index];
            }
        }
        this.setState({files: tmp, lastClickedRowIdx: null});
        this.props.updateFilesList(tmp);
    }

    saveForm() {
        doBlockPage();
        let filesDelIds = [];
        this.state.filesDelIds.forEach((item) => {
            filesDelIds.push({id: item});
        });
        let data = {
            fieldName: this.props.fieldName,
            filesDelIds: filesDelIds
        };
        let oldFiles = [];
        $(this.modal.current).find('tbody > tr').each((index, element) => {
            let thisObj = $(element);
            let oldFile = {
                id: thisObj.find('input[name="file-id"]:first').val(),
                title: thisObj.find('input[name="title"]:first').val(),
                file_name: thisObj.find('input[name="file_name"]:first').val(),
            };
            const signature = thisObj.find('select[name="signature_id"]:first');
            if (signature.length) {
                oldFile.signature_id = signature.val();
            }
            oldFiles.push(oldFile);
        });
        data.oldFiles = oldFiles;
        saveFiles(data)
            .then(result => {
                if (result.fieldsWithError !== undefined) {
                    this.showErrorsInModalFields(result.fieldsWithError);
                } else {
                    this.hideAllErrors();
                    this.updateCurrentFilesList(result);
                    this.setState({sortColumn: 'sort_id', sortType: 'asc', filesDelIds: []});
                    notify.showMessage('onSuccess', 'Данные сохранены');
                }
            })
            .catch(err => {
                notify.showMessage('onError', err);
            })
            .finally(() => {
                doUnblockPage();
            });
    }

    showErrorsInModalFields(errors) {
        $(this.modal.current).find('input').parent().removeClass('has-error');
        for (let fieldName in errors) {
            errors[fieldName].forEach(index => {
                $(this.modal.current).find('input[name=' + fieldName + ']:eq(' + index + ')').parent().addClass('has-error');
            })
        }
    }

    hideAllErrors() {
        $(this.modal.current).find('input').parent().removeClass('has-error');
    }

    componentDidMount() {

        $(this.modal.current).modal('toggle')
            .on('hidden.bs.modal', () => {
                ReactDOM.unmountComponentAtNode(document.getElementById('dialog'));
            })
            .on('hide.bs.modal', () => {
                ReactDOM.unmountComponentAtNode(document.getElementById('dialog'));
            });
        initToggle();
        // эта заглушка помогает когда на форме присутствуют несколько модалок
        // без этого кода инпуты не редактируются.
        $(this.modal.current).on('shown.bs.modal', function () {
            $(document).off('focusin.modal');
        });

        $("#upload_file_list").sortable(
            {
                containment: "#upload_file_container",
                axis: "y",
                helper: function (e, ui) {
                    ui.children().each(function () {
                        $(this).width($(this).width());
                    });
                    return ui;
                }
            }
        );
    }

    sortColumn(column) {
        let sortType = this.state.sortType;
        if (column === this.state.sortColumn) {
            if (sortType === 'asc') {
                sortType = 'desc';
            } else {
                sortType = 'asc';
            }
        }
        this.setState({sortColumn: column, sortType: sortType});
    }

    clickOnRow(fileId, e) {
        var nowClickedRowIdx = null;
        const nonDeletedFiles = [];
        //в рендере не выводятся удаленные ряды, нам нужен индекс неудаленных ряндов,
        //будем использовать, данный индекс при выделении рядов через SHIFT
        for (let index in this.state.files) {
            let file = this.state.files[index];
            if (this.state.filesDelIds.indexOf(file.id) == -1) {
                nonDeletedFiles.push(file);
            }
        }

        for (let index in nonDeletedFiles) {
            if (nonDeletedFiles[index].id == fileId) {
                nowClickedRowIdx = parseInt(index);
                break;
            }
        }

        if (e.shiftKey && this.state.lastClickedRowIdx != null && nowClickedRowIdx != null) {
            let from, to;
            if (nowClickedRowIdx > this.state.lastClickedRowIdx) {
                from = this.state.lastClickedRowIdx;
                to = nowClickedRowIdx;
            } else {
                from = nowClickedRowIdx;
                to = this.state.lastClickedRowIdx;
            }

            $(this.modal.current).find('input[name=file-select]')
                .each((idx, element) => {
                    if (idx >= from && idx <= to) {
                        $(element).prop('checked', true);
                    }
                });
        }
        this.setState({lastClickedRowIdx: nowClickedRowIdx});
    };

    render() {
        return (
            <div className="modal fade" id="file-edit-dialog" ref={this.modal}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal">×</button>
                            <h4 className="modal-title">
                                Редактирование файлов
                                <div className="pull-right"><span>{this.props.title}<Nbsp/><Nbsp/></span></div>
                            </h4>
                        </div>
                        <div className="modal-body">
                            <FileUploadBlock {...this.state} {...this.props}/>
                            <br/>

                            <FileDeleteButton deleteFiles={this.state.deleteFiles}/>
                            <br/>
                            <div className="form-group" id="upload_file_container">
                                <table className="table table-condensed table-bordered">
                                    <thead>
                                    <tr>
                                        <th />
                                        <th className="text-center">
                                            <input type="checkbox" className="select-all-files" data-toggle="tooltip"
                                                   data-placement="right" checked={this.state.checked ? 'checked' : ''}
                                                   title="" data-original-title="Выбрать все"
                                                   onChange={(e) => this.selectAll(e)}/>
                                        </th>
                                        <th className="text-center cursor-pointer" title="Сортировать по полю"
                                            onClick={() => {this.sortColumn('sort_id')}}>
                                            №&nbsp;
                                            {this.state.sortColumn === 'sort_id'
                                                ? (this.state.sortType === 'asc'
                                                    ? <span className="glyphicon glyphicon-sort-by-attributes text-info" />
                                                    : <span className="glyphicon glyphicon-sort-by-attributes-alt text-info" />)
                                                : null}
                                        </th>
                                        <th className="cursor-pointer" title="Сортировать по полю"
                                            onClick={() => {this.sortColumn('title')}}>
                                            Заголовок ссылки (на любом языке)&nbsp;
                                            {this.state.sortColumn === 'title'
                                                ? (this.state.sortType === 'asc'
                                                    ? <span className="glyphicon glyphicon-sort-by-attributes text-info" />
                                                    : <span className="glyphicon glyphicon-sort-by-attributes-alt text-info" />)
                                                : null}
                                        </th>
                                        <th className="cursor-pointer" title="Сортировать по полю"
                                            onClick={() => {this.sortColumn('file_name')}}>
                                            Название файла&nbsp;
                                            {this.state.sortColumn === 'file_name'
                                                ? (this.state.sortType === 'asc'
                                                    ? <span className="glyphicon glyphicon-sort-by-attributes text-info" />
                                                    : <span className="glyphicon glyphicon-sort-by-attributes-alt text-info" />)
                                                : null}
                                        </th>
                                        {Number(this.props.settings['is_simple_signature'])
                                            ? <th className="td-file-signature">ЭЦП</th>
                                            : null}
                                        <th className="td-file-status">
                                            Дата загрузки
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody id="upload_file_list">
                                    {
                                        this.state.files.map((file, index) => {
                                            if (file !== undefined) {
                                                return (<FileEdit {...file}
                                                                  index={index}
                                                                  filesDelIds={this.state.filesDelIds}
                                                                  clickHandler={this.clickOnRow.bind(this)}
                                                                  changeHandler={this.handleChangeEvent.bind(this)}
                                                                  key={file.id}
                                                                  settings={this.props.settings}
                                                                  monolitSettings={this.props.monolitSettings}
                                                />)
                                            }
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={(e) => this.saveForm(e)}>
                                Сохранить
                            </button>
                            <button type="button" className="btn btn-default" data-dismiss="modal">Закрыть</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ReactModalFileEdit;
